import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import { listElementsToArray } from '../../responsibilitiesUtils';
import { validateEmail } from '../../formValidators';
import logoImg from '../../../assets/images/Logo_Gray.svg';
import dollarGreen from '../../../assets/images/icons/dollar-sign-green.svg';
import capitalize from '../../stringUtils';
import { formatCurrency } from '../../numberUtils';
import './ProjectShare.scss';
var renderSkills = function renderSkills(skills, t) {
  return skills.map(function (s) {
    return /*#__PURE__*/React.createElement("span", {
      className: "badge small me-3 ".concat(t.badge_class, " ").concat(s[1] ? 'priority' : '')
    }, s[0], s[1] ? /*#__PURE__*/React.createElement("strong", {
      className: "pl-2"
    }, /*#__PURE__*/React.createElement("i", null, "*Must have")) : null);
  });
};
var renderTags = function renderTags(tags) {
  return tags.map(function (t) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tags mt-3  mb-3  project-tags"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-text-3 medium-weight skill-name"
    }, t.skill_name), t.not_applicable ? /*#__PURE__*/React.createElement("span", {
      className: "body-text-3 muted-gray-text"
    }, "Not Applicable") : renderSkills(t.skills, t));
  });
};
var renderQualifications = function renderQualifications(qualifications) {
  return qualifications.map(function (q) {
    return q.list.length ? /*#__PURE__*/React.createElement("div", {
      className: "tags mt-3 mb-3 project-qualifications"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-text-3 medium-weight qualification-name"
    }, q.name), /*#__PURE__*/React.createElement("ul", {
      className: "body-text-3"
    }, q.list.map(function (l) {
      return /*#__PURE__*/React.createElement("li", null, l);
    }))) : '';
  });
};
var renderSkillsQualifications = function renderSkillsQualifications(qualifications, tags) {
  return [/*#__PURE__*/React.createElement("h4", {
    className: "highlight-text mt-3"
  }, "SKILLS"), renderTags(tags), qualifications.map(function (q) {
    return q.list;
  }).every(function (list) {
    return list.length === 0;
  }) ? null : [/*#__PURE__*/React.createElement("h4", {
    className: "highlight-text mt-3"
  }, "QUALIFICATIONS"), renderQualifications(qualifications)]];
};
var renderOpportunitiesButton = function renderOpportunitiesButton(notInterestedUrl, customClass) {
  return /*#__PURE__*/React.createElement("a", {
    href: notInterestedUrl,
    className: "btn btn-secondary highlight-text not-interested-project-share ".concat(customClass)
  }, "See all opportunities");
};
var ProjectShare = /*#__PURE__*/function (_Component) {
  function ProjectShare(props) {
    var _this;
    _classCallCheck(this, ProjectShare);
    _this = _callSuper(this, ProjectShare, [props]);
    _this.state = {
      errorMessage: null,
      email: ''
    };
    _this.handleValidation = _this.handleValidation.bind(_this);
    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
    return _this;
  }
  _inherits(ProjectShare, _Component);
  return _createClass(ProjectShare, [{
    key: "handleEmailChange",
    value: function handleEmailChange(e) {
      this.setState({
        email: e.target.value
      });
    }
  }, {
    key: "handleValidation",
    value: function handleValidation(e) {
      var email = this.state.email;
      var emailValidation = validateEmail(email);
      if (emailValidation.error) {
        e.preventDefault();
        this.setState({
          errorMessage: emailValidation.error
        });
      } else {
        this.setState({
          errorMessage: null
        });
      }
      return null;
    }
  }, {
    key: "renderApplyButton",
    value: function renderApplyButton() {
      var customClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var errorMessage = this.state.errorMessage;
      var _this$props = this.props,
        isConsultant = _this$props.isConsultant,
        acceptingProposals = _this$props.acceptingProposals,
        submitInterestProjectUrl = _this$props.submitInterestProjectUrl,
        sourced = _this$props.sourced,
        csrfToken = _this$props.csrfToken,
        email = _this$props.email,
        recommendationId = _this$props.recommendationId,
        candidateSource = _this$props.candidateSource;
      if (!acceptingProposals) {
        return /*#__PURE__*/React.createElement("p", {
          className: "mt-2 mb-2"
        }, "This project is not accepting proposals at this time.");
      }
      if (isConsultant) {
        return /*#__PURE__*/React.createElement("form", {
          action: submitInterestProjectUrl,
          acceptCharset: "UTF-8",
          method: "post",
          className: "text-center mt-2 mb-2"
        }, /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "authenticity_token",
          value: csrfToken
        }), /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "sourced",
          value: sourced
        }), /*#__PURE__*/React.createElement("button", {
          type: "submit",
          className: "btn btn-primary ".concat(customClass, " width-100p"),
          id: "project-share-apply-button"
        }, "Apply Now"));
      }
      return /*#__PURE__*/React.createElement("form", {
        action: submitInterestProjectUrl,
        acceptCharset: "UTF-8",
        method: "post"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "authenticity_token",
        value: csrfToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "recommendation_id",
        value: recommendationId
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "sourced",
        value: sourced
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "candidate_source",
        value: candidateSource
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "email",
        className: "medium-weight"
      }, "Enter your email & Apply Now:"), /*#__PURE__*/React.createElement("div", {
        className: "email-input"
      }, /*#__PURE__*/React.createElement("input", {
        type: "email",
        name: "email",
        id: "email",
        className: "form-control share-email-input",
        placeholder: "Enter your email",
        defaultValue: email,
        required: true,
        onChange: this.handleEmailChange
      }), errorMessage ? /*#__PURE__*/React.createElement("div", {
        className: "error-text"
      }, errorMessage) : ''), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "submit",
        name: "commit",
        id: "project-share-apply-button",
        className: "btn btn-primary ".concat(customClass),
        value: "Apply Now",
        onClick: this.handleValidation
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        name = _this$props2.name,
        officeAndWorkType = _this$props2.officeAndWorkType,
        workCommitment = _this$props2.workCommitment,
        jobTitles = _this$props2.jobTitles,
        description = _this$props2.description,
        responsibilities = _this$props2.responsibilities,
        idealCandidateDescription = _this$props2.idealCandidateDescription,
        duration = _this$props2.duration,
        startDate = _this$props2.startDate,
        travelLocations = _this$props2.travelLocations,
        workLocation = _this$props2.workLocation,
        acceptingProposals = _this$props2.acceptingProposals,
        notInterestedUrl = _this$props2.notInterestedUrl,
        rootUrl = _this$props2.rootUrl,
        tags = _this$props2.tags,
        qualifications = _this$props2.qualifications,
        showProjectEmploymentType = _this$props2.showProjectEmploymentType,
        employmentType = _this$props2.employmentType,
        basePayHidden = _this$props2.basePayHidden,
        budgetMinimum = _this$props2.budgetMinimum,
        budgetMaximum = _this$props2.budgetMaximum;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "project-detail"
      }, showProjectEmploymentType && /*#__PURE__*/React.createElement("div", {
        className: "".concat(employmentType, "-badge")
      }, capitalize(employmentType), ' ', "Position"), /*#__PURE__*/React.createElement("div", {
        className: "g-row g-flex-justify-space-between project-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-7"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "demibold project-name mt-2 mb-2"
      }, name), acceptingProposals && /*#__PURE__*/React.createElement("h6", {
        className: "warning-text mt-0"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-running"
      }), "Opportunity closes soon!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1"
      }, jobTitles && "Relevant Job Titles(s): ".concat(jobTitles)), /*#__PURE__*/React.createElement("div", {
        className: "project-description"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "highlight-text mt-25 mb-2"
      }, "DESCRIPTION"), /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement("div", {
        id: "responsibilities",
        className: "mt-4 project-responsibilities"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "demi-bold highlight-text mb-2"
      }, "RESPONSIBILITIES"), /*#__PURE__*/React.createElement("div", {
        className: "g-column"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "responsibility_areas"
      }, responsibilities.map(function (r) {
        return /*#__PURE__*/React.createElement("li", {
          key: r
        }, r);
      })))), /*#__PURE__*/React.createElement("div", {
        id: "ideal-candidate-description",
        className: "mt-4 project-ideal-candidate"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "demi-bold highlight-text mb-2"
      }, "IDEAL CANDIDATE"), /*#__PURE__*/React.createElement("div", {
        className: "g-column"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "responsibility_areas"
      }, listElementsToArray(idealCandidateDescription).map(function (r) {
        return /*#__PURE__*/React.createElement("li", {
          key: r
        }, r);
      })))), employmentType === 'full_time' && basePayHidden === false && /*#__PURE__*/React.createElement("div", {
        id: "annual-base-salary",
        className: "mt-4 annual-base-salary"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SVG, {
        src: dollarGreen,
        alt: "Dollar"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Annual base salary range:\xA0", formatCurrency(budgetMinimum), ' ', "-", formatCurrency(budgetMaximum)), /*#__PURE__*/React.createElement("p", {
        className: "disclaimer"
      }, "Pay may vary outside of this range depending on a number of factors, including but not limited to a candidate\u2019s qualifications, skills, competencies, experience, and location.")))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 g-flex-4 share-email-form d-none d-sm-block"
      }, this.renderApplyButton('bigger-button'), /*#__PURE__*/React.createElement("h4", {
        className: "highlight-text mt-25 mb-2"
      }, "COMMITMENT"), /*#__PURE__*/React.createElement("div", {
        className: "commitment work-commitment"
      }, employmentType === 'full_time' ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock"
      }), "Full Time") : /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock"
      }), /*#__PURE__*/React.createElement("strong", null, "".concat(workCommitment, " hrs/week")), ' ', "for", /*#__PURE__*/React.createElement("strong", null, "".concat(duration, " \n                    month duration")))), workLocation && /*#__PURE__*/React.createElement("div", {
        className: "commitment work-location"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        className: "fas  fa-map-marker-alt"
      }), officeAndWorkType)), startDate && /*#__PURE__*/React.createElement("div", {
        className: "commitment start-date"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-calendar-day"
      }), ' ', startDate)), travelLocations ? /*#__PURE__*/React.createElement("div", {
        className: "commitment travel"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-plane"
      }), "Travel Requirements - ".concat(travelLocations))) : '', /*#__PURE__*/React.createElement("div", {
        className: "tags mb-2 d-none d-nd-block"
      }, renderSkillsQualifications(qualifications, tags)))), /*#__PURE__*/React.createElement("div", {
        className: "tags my-2 d-flex d-md-none"
      }, renderSkillsQualifications(qualifications, tags))), /*#__PURE__*/React.createElement("div", {
        className: "d-none d-sm-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("h1", {
        className: " mb-3 "
      }, "Not interested in this opportunity?"), renderOpportunitiesButton(notInterestedUrl))), /*#__PURE__*/React.createElement("div", {
        className: "d-block d-sm-none mt-3 mx-3 mb-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "share-email-form"
      }, this.renderApplyButton()), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, renderOpportunitiesButton(notInterestedUrl, 'width-100p'))), /*#__PURE__*/React.createElement("div", {
        className: "project-clora-how-to-apply"
      }, /*#__PURE__*/React.createElement("h1", {
        className: " mb-3 "
      }, "Apply now to be 1 of the 3 candidates for this position:"), /*#__PURE__*/React.createElement("div", {
        className: "g-row g-flex-justify-space-between"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-30 how-to upload-resume"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold me-2"
      }, "1."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "demibold mb-5"
      }, "Upload your resume"), /*#__PURE__*/React.createElement("p", null, "Apply now to submit your resume to Clora.")))), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-30 how-to submit-proposal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold me-2"
      }, "2."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "demibold mb-5"
      }, "Answer a few questions"), /*#__PURE__*/React.createElement("p", null, "Tell the company why you're a good fit for their needs.")))), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-30 how-to interview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold me-2"
      }, "3."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "demibold mb-5"
      }, "Interview with the company"), /*#__PURE__*/React.createElement("p", null, "If selected, Clora will put you in contact with the company.")))))), /*#__PURE__*/React.createElement("div", {
        className: "about-clora-blurb"
      }, /*#__PURE__*/React.createElement("a", {
        href: rootUrl
      }, "Clora"), "'s intelligent selection engine finds projects from top life science companies that match your experience and skills. All projects are vetted by life science professionals.", /*#__PURE__*/React.createElement("img", {
        src: logoImg,
        alt: "Clora",
        className: "clf-logo-footer"
      })));
    }
  }]);
}(Component);
ProjectShare.propTypes = {
  name: PropTypes.string.isRequired,
  jobTitles: PropTypes.string,
  workCommitment: PropTypes.number.isRequired,
  officeAndWorkType: PropTypes.string,
  travelLocations: PropTypes.string,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  idealCandidateDescription: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string.isRequired,
  acceptingProposals: PropTypes.bool.isRequired,
  isConsultant: PropTypes.bool.isRequired,
  submitInterestProjectUrl: PropTypes.string.isRequired,
  sourced: PropTypes.string.isRequired,
  notInterestedUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  rootUrl: PropTypes.string.isRequired,
  recommendationId: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  qualifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  candidateSource: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool.isRequired,
  employmentType: PropTypes.string.isRequired,
  budgetMinimum: PropTypes.string.isRequired,
  budgetMaximum: PropTypes.string.isRequired,
  basePayHidden: PropTypes.bool.isRequired
};
ProjectShare.defaultProps = {
  jobTitles: null,
  email: null,
  candidateSource: null
};
export default ProjectShare;